
import React from 'react';
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import { 
  SidebarProvider, 
  SidebarTrigger,
  SidebarInset 
} from "@/components/ui/sidebar";
import { ScrollArea } from "@/components/ui/scroll-area";
import { MarketAnalysisSidebarNew } from './MarketAnalysisSidebarNew';

interface MarketAnalysisLayoutNewProps {
  children: React.ReactNode;
}

export const MarketAnalysisLayoutNew = ({ children }: MarketAnalysisLayoutNewProps) => {
  const navigate = useNavigate();

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <MarketAnalysisSidebarNew />
        
        <SidebarInset className="flex-1">
          {/* Sticky Header with Safe Area - iOS PWA Compatible */}
          <header 
            className="sticky top-0 z-50 flex shrink-0 items-center gap-4 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 px-4"
            style={{ 
              paddingTop: 'env(safe-area-inset-top)', 
              height: 'calc(4rem + env(safe-area-inset-top))'
            }}
          >
            <SidebarTrigger className="-ml-1" />
            
            {/* Dashboard Navigation Button */}
            <Button
              variant="ghost"
              onClick={() => navigate('/')}
              className="text-muted-foreground hover:text-foreground hover:bg-accent min-h-[44px] px-4"
            >
              <Home className="h-4 w-4 mr-2" />
              Dashboard
            </Button>
          </header>

          {/* Main Content with Custom ScrollArea - iOS PWA Compatible height calculation */}
          <ScrollArea 
            className="w-full"
            style={{ height: 'calc(100vh - 4rem - env(safe-area-inset-top))' }}
          >
            <div className="p-4 sm:p-6 min-h-full">
              {children}
            </div>
          </ScrollArea>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};
